export default __webpack_public_path__ + "images/logout.300f04ea.svg";